import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { confirmForgotPassword } from '../../lib/auth-api'
import PasswordTextField from '../sign-up-form/password-text-field'
import { passwordValidation } from '../sign-up-form/validation'

const useStyles = makeStyles(theme => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
}))

const formSchema = yup.object().shape({
  confirmationCode: yup.string().required('This field is required'),
  password: passwordValidation.required('This field is required'),
})

const ChangePasswordForm = ({ onSuccess, username, code }) => {
  const classes = useStyles()
  const [submissionError, setSubmissionError] = useState(null)
  const { register, handleSubmit, errors, formState } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(formSchema),
  })
  const { isSubmitting } = formState

  const onFormSubmit = async (formValues) => {
    setSubmissionError(null)
    const resp = await confirmForgotPassword(username, formValues.password, formValues.confirmationCode)
    if (resp.success) {
      onSuccess && onSuccess({ message: resp.message })
    } else {
      setSubmissionError(resp.message)
    }
  }

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <TextField
        className={classes.formField}
        name="confirmationCode"
        label="Password Reset Code"
        defaultValue={code}
        inputRef={register}
        inputProps={{
          inputmode: 'numeric',
          pattern: '[0-9]*',
        }}
        error={!!errors.confirmationCode}
        helperText={errors.confirmationCode && errors.confirmationCode.message}
      />
      <PasswordTextField
        className={classes.formField}
        name="password"
        label="New Password"
        type="password"
        inputRef={register}
        autoFocus={code}
        error={!!errors.password}
        helperText={errors.password && errors.password.message}
      />
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        type="submit"
        disabled={isSubmitting}
      >
        Change Password
      </Button>
      {submissionError && <FormHelperText error={true}>{submissionError}</FormHelperText>}
    </form>
  )
}

export default ChangePasswordForm
